// extracted by mini-css-extract-plugin
module.exports = {"item":"InfoItemRow_item__xnTjt","slide-in-out":"InfoItemRow_slide-in-out__0Blio","fade-in-out":"InfoItemRow_fade-in-out__3HIVd"};